import { render, staticRenderFns } from "./ConsultDialog.vue?vue&type=template&id=2ffe013c&scoped=true&"
import script from "./ConsultDialog.vue?vue&type=script&lang=js&"
export * from "./ConsultDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsultDialog.vue?vue&type=style&index=0&id=2ffe013c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe013c",
  null
  
)

export default component.exports